import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import {updateLessonNodes} from "api/services/node-service";

export const useUpdateLessonNodes = () => {
    const { callAPI, loading } = useWorkspaceApiCall(updateLessonNodes, 'updateLessonNodes.success', 'updateLessonNodes.error');

    return { updateLessonNodes: callAPI, isLoading: loading };
}
